import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { IBotHousingMergeContainerState } from '../../../../../../shared/models/bot-housing-merge-container-state';

@Component({
    selector: 'tripmakery-in-progress-stats-modal',
    templateUrl: './in-progress-stats-modal.component.html',
    styleUrls: ['./in-progress-stats-modal.component.css'],
})
export class InProgressStatsModal implements OnInit {
    stats: IBotHousingMergeContainerState;

    constructor(private bsModalRef: BsModalRef) {}

    public close(): void {
        this.bsModalRef.hide();
    }

    ngOnInit(): void {}
}
